import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { captureAppException } from '../lib/monitoring'

type Props = { children: ReactNode }
type State = { hasError: boolean; error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    captureAppException(error, {
      tags: {
        screen: 'ErrorBoundary',
        user_role: 'unknown',
      },
      extra: {
        componentStack: info.componentStack,
      },
    })
    console.error('ErrorBoundary caught:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[var(--jnavi-bg)]">
          <div className="mx-4 max-w-md rounded-xl border border-red-200 bg-white p-8 text-center shadow">
            <div className="text-lg font-semibold text-red-700">エラーが発生しました</div>
            <p className="mt-2 text-sm text-slate-600">
              予期しないエラーが発生しました。ページを再読み込みしてください。
            </p>
            <p className="mt-2 text-xs text-slate-400">
              {this.state.error?.message}
            </p>
            <button
              className="mt-4 rounded-lg bg-[var(--jnavi-navy)] px-4 py-2 text-sm font-medium text-white hover:brightness-110"
              onClick={() => window.location.reload()}
            >
              再読み込み
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
